import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "home-page"
};
import { ref } from 'vue';
import NavBar from '@/components/layout/NavBar.vue';
import Footer from '@/components/layout/Footer.vue';
import TrialDialog from '@/components/common/TrialDialog.vue';
import ScrollProgress from '@/components/common/ScrollProgress.vue';
import BackToTop from '@/components/common/BackToTop.vue';
import HomeSection from '@/components/sections/HomeSection.vue';
import HomeContent from '@/components/sections/HomeContent.vue';
export default {
  __name: 'Home',
  setup(__props) {
    const dialogVisible = ref(false);
    const handleDialogClosed = () => {
      dialogVisible.value = false;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(NavBar), _createVNode(ScrollProgress), _createElementVNode("main", null, [_createVNode(HomeSection), _createVNode(HomeContent, {
        onTrial: _cache[0] || (_cache[0] = $event => dialogVisible.value = true)
      })]), _createVNode(Footer), _createVNode(BackToTop), _createVNode(TrialDialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogVisible.value = $event),
        onClosed: handleDialogClosed
      }, null, 8, ["modelValue"])]);
    };
  }
};